import { ServiceMaker, methods, services } from "@/services";

export const paymentHistory = data =>
  ServiceMaker(
    "/subscription-payments/subscription-pricing/filter/my",
    methods.POST,
    services.master,
    data
  );

export const createPartnerPayment = data =>
  ServiceMaker(
    "/subscription-payments/subscription-pricing",
    methods.POST,
    services.master,
    data
  );
